angular.module('elogbooksServices').service('statutoryTypes', function($http) {

    this.getAll = function () {
        return $http.get('/data/statutoryTypes.json').then(function(response){
            return response.data;
        });
    }

    return this;
});
